import { useSelector } from "react-redux";
import { useScreenWidth } from "./useScreenWidth";

export const useIsMinimizedMenu = () => {
  const isMobile = useScreenWidth(991);
  const isMinimized = useSelector((state) => state.menu.isMinimized);
  return isMinimized && !isMobile;
};